import { Button, Subtitle, Title, Wrapper } from "./styles"

const PageNotFound = () => {
  return (
    <Wrapper>
      <Title>404</Title>
      <Subtitle>Oops! The page you're looking for doesn't exist.</Subtitle>
      <Button href="/">GO HOME</Button>
    </Wrapper>
  )
}

export default PageNotFound
